import React, { FC } from 'react';
import { Icon } from '@goldbely/explore-component-library';

import { LazyImgix } from 'src/explore/elements/LazyImgix';

import styles from './index.module.sass';

interface LogoProps {
  alt?: string;
  src?: string;
}

const Logo: FC<LogoProps> = ({ alt, src }) => (
  <div className={styles.logo}>
    {src ? <LazyImgix alt={alt} src={src} /> : <Icon ariaLabel="Goldbelly" name="goldbelly" />}
  </div>
);

export default Logo;
